<template>
    <div>
        <div id="page">
<Header></Header>
        <div class="wp">
            <div class="consign-info">
                <div class="consign-info-caption">招标信息</div>
                <div class="consign-item">
                    <div class="lab">委托人</div>
                    <div class="val">{{ entrust_info.bider_name }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">发布人类型</div>
                    <div class="val">{{ entrust_info.faburen_type }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">委托目标</div>
                    <div class="val">{{ entrust_info.target }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">委托面积</div>
                    <div class="val">{{ entrust_info.area }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">委托类型</div>
                    <div class="val">{{ entrust_info.type }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">预算金额</div>
                    <div class="val">{{ entrust_info.budget }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">其他要求</div>
                    <div class="val">{{ entrust_info.detail }}</div>
                </div>
            </div>
            <div class="consign-info">
                <div class="consign-info-caption">招标信息</div>
                <div class="consign-item">
                    <div class="lab">招标房源</div>
                    <div class="val"><div class="btn01"  @click="showPop = true">选择房源</div></div>
                </div>
                <div class="consign-item">
                    <div class="lab">房源名称</div>
                    <div class="val">{{ house_info.house_name }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">详细地址</div>
                    <div class="val">{{ house_info.address }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">面　　积</div>
                    <div class="val">{{ house_info.area }}</div>
                </div>
                <div class="consign-item">
                    <div class="lab">价　　格</div>
                    <div class="val">{{ house_info.rent_sale_price }}</div>
                </div>

                <div class="formw01-item-ft">
                    <div class="btn s1" @click="$router.back()">取　消</div>
                    <div class="btn s2" @click="submit">提　交</div>
                </div>
            </div>
        </div>
        </div>
        
        <Footer></Footer>

        <van-popup v-model="showPop" :overlay="true" @close="closePop">
            <div class="swipe01 pop-swipe01">
                <div class="swipe01-head swipe01-tr">
                    <div class="swipe01-td">房源名称</div>
                    <div class="swipe01-td">地址</div>
                    <div class="swipe01-td">面积</div>
                    <div class="swipe01-td">价格</div>
                    <div class="swipe01-td" style="text-align:center;">选择</div>
                </div>
                <div class="swipe01-body">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad">
                            <label v-for="item in house_list">
                                <div class="swipe01-tr">
                                    <div class="swipe01-td">{{ item.house_name }}</div>
                                    <div class="swipe01-td">{{ item.address }}</div>
                                    <div class="swipe01-td">{{ item.area }}</div>
                                    <div class="swipe01-td">{{ item.rent_sale_price }}</div>
                                    <div class="swipe01-td swiper01-radio"><input type="radio" name="house_item" :value="item.house_id" v-model="house_id"><span class="radio"></span></div>
                                </div>
                            </label>
                    </van-list>
                </div>
            </div>
            <div class="formw01-item-ft pop">
                <div class="btn s1" @click="closePop">取　消</div>
                <div class="btn s2" @click="confirm">提　交</div>
            </div>
        </van-popup>

    </div>
</template>

<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Popup, List, Toast } from 'vant'

    export default {
        name: "Bided",
        data: function(){
            return {
                showPop: false,
                id: '',
                entrust_info: {},
                house_list: [],
                page: 1,
                loading: false,
                finished: false,
                house_id: '',
                house_info: {}
            }
        },
        components: {
            Header, Footer,
            [Popup.name]: Popup,
            [Toast.name]: Toast,
            [List.name]: List
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getInfo();
            this.bideHouseList();
        },
        methods: {
            getInfo(){
                const _this = this;
                _this.api.bideUnConfirm({entrust_id: _this.id}).then(function(response){
                    _this.entrust_info = response.entrust_info;
                })
            },
            bideHouseList(){
                const _this = this;
                _this.api.bideHouseList({
                    page: _this.page,
                    pageSize: 20
                }).then(function(response){
                    _this.page++;
                    _this.loading = false;
                    if (response.house_list == 0) {
                        _this.finished = true;
                    }
                    _this.house_list = _this.house_list.concat(response.house_list);
                })
            },
            bideHouseView(){
                const _this = this;
                _this.api.bideHouseView({house_id: _this.house_id}).then(function(response){
                    _this.house_info = response.house_info;
                })
            },
            closePop(){
                this.showPop = false;
            },
            confirm(){
                this.showPop = false;
                this.bideHouseView();
            },
            submit(){
                const _this = this;
                let params = new FormData();
                params.append('entrust_id', _this.id);
                params.append('house_id', _this.house_id);
                _this.api.confirmBide(params).then(function(response){
                    if (response.status == 1) {
                        _this.$router.back();
                    } else {
                        Toast(response.msg)
                    }
                })
            },
            onLoad(){
                setTimeout(()=>{
                    this.bideHouseList()
                }, 500)
            }
        }

    }
</script>

<style scoped>
    /deep/ .consign-info {margin: 0;padding: .4rem 0}
    /deep/ .consign-info + .consign-info {border-top: 1px solid #989898;}
    /deep/ .pop-swipe01 {width: 6.9rem;}
    /deep/ .swipe01-body .swipe01-tr {border-bottom: 1px solid #989898;}
    /deep/ .formw01-item-ft.pop {padding: .3rem;}
    /deep/ .swipe01-body {max-height: 50vh;overflow-y: auto;}
</style>